import { ReactNode } from "react";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { useStyle } from "./style";
import WarningIcon from "@static/icons/Warning.svg";

interface IBroadbandCardHeaderProps {
    title: string;
    statusMessage?: string | ReactNode;
    hasError?: boolean;
    errorBannerMessage?: string;
    deleteLabel?: string;
    showEditIcon?: boolean;
    onEdit(): void;
    onDelete?(): void;
}

export const BroadbandCardHeader = (props: IBroadbandCardHeaderProps) => {
    const { title, statusMessage, hasError, errorBannerMessage, deleteLabel, onDelete, showEditIcon, onEdit } = props;
    const { classes } = useStyle();

    return (
        <Grid alignItems="center" container justifyContent="space-between">
            <Grid container item spacing={2} xs={10}>
                <Grid item xs={12}>
                    <Typography className={classes.title} variant="h2">
                        {title}
                    </Typography>
                </Grid>
                {statusMessage && (
                    <Grid item xs={12}>
                        <Typography className={classes.statusMessage} variant="normal">
                            {statusMessage}
                        </Typography>
                    </Grid>
                )}
                {hasError && errorBannerMessage && (
                    <Grid item xs={12}>
                        <Box className={classes.errorBanner}>
                            <WarningIcon className={classes.errorIcon} />
                            <Typography className={classes.errorBannerText} variant="small">
                                {errorBannerMessage}
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
            <Grid alignItems="flex-end" container direction="column" item xs={2}>
                <Grid item>
                    <IconButton
                        aria-label={deleteLabel}
                        className={classes.deleteButton}
                        data-testid="delete-broadband-offer-icon"
                        onClick={onDelete}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Grid>
                {showEditIcon && (
                    <Grid item>
                        <IconButton aria-label="Edit" className={classes.editButton} onClick={onEdit}>
                            <EditIcon />
                        </IconButton>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};
